module.exports = __webpack_public_path__ + "img/status_statement_of_applicability.b95c29b1.gif";